module.exports = __webpack_public_path__ + "static/media/ProductPerformance.f2ee330b.svg";